import Vue from 'vue';
import Vuex from 'vuex';
import VueCookies from 'vue-cookies'
import axios from 'axios';
Vue.use(VueCookies)
Vue.use(Vuex);
const store = new Vuex.Store({
    state:{
        showbtn:true,
        webinfo:'http://oa.lwc.cn/',
        fileDomain:'https://files.actintl.net',
        access_token:'',
        openid:'',
        meeting:{},
        mid:'',
        network:true,
        user:{},
        lang:'zh-cn'
    },
    getters: {
        mid(state){
            if(!state.mid){
                state.mid = window.localStorage.getItem("mid");
            }
            return state.mid
        },
        setShowbtn(state){
            let showbtn = VueCookies.get("showbtn");
            if(!state.showbtn){
                state.showbtn = window.localStorage.getItem("showbtn")?window.localStorage.getItem("showbtn"):showbtnshowbtn;
            }
            return state.showbtn
        },
        user(state){
            let users = VueCookies.get("user");
            if(!state.user){
                state.user = users?users:JSON.parse(window.localStorage.getItem("user"));
            }
            return state.user
        },
        lang(state){
            let lang = VueCookies.get("lang");
            if(!state.lang){
                state.lang = lang?lang:JSON.parse(window.localStorage.getItem("lang"));
            }
            return state.lang
        },
        access_token(state){
            let token = VueCookies.get("access_token");
            if(!state.access_token){
                state.access_token = token?token:window.localStorage.getItem("access_token");
            }
            return state.access_token
        },
        openid(state){
            if(!state.openid){
                state.openid = window.localStorage.getItem("openid");
            }
            return state.openid
        },
    },
    mutations: {
        setLang(state,lang){
            localStorage.setItem("lang", JSON.stringify(lang));
            VueCookies.set("lang",lang,"7d","/");
            state.lang = lang;
        },
        changeNetwork(state,network){
            localStorage.setItem("network", JSON.stringify(network));
            state.network = network;
        },
        setShowbtn(state,showbtn){
            localStorage.setItem("showbtn", JSON.stringify(showbtn));
            VueCookies.set("showbtn",showbtn,"7d","/");
            state.showbtn = showbtn;
        },
        setmid(state,mid){
            localStorage.setItem("mid", JSON.stringify(mid));
            state.mid = mid;
        },
        shareId(state,shareId){
            localStorage.setItem("shareId", JSON.stringify(shareId));
            state.shareId = shareId;
        },
        setToken (state, token) {
            localStorage.setItem("access_token", JSON.stringify(token));
            VueCookies.set("access_token",token,"7d","/");
            state.access_token = token;
        },
        setLoginUser(state,user){
            localStorage.setItem("user", JSON.stringify(user));
            VueCookies.set("user",user,"7d","/");
            state.user = user;
        },
        setOpenid(state,openid){
            localStorage.setItem("openid", JSON.stringify(openid));
            state.openid = openid;
        },
        logout (state){
            VueCookies.remove('access_token')
            VueCookies.remove('user')
            state.access_token=''
            state.user=''
            localStorage.clear()
        },
    },
    actions:{
        fetchUsers({commit}){
            let token = this.getters.access_token
            axios.get('/api/visionAward/getUserInfo',{params:{access_token:token}}).then((response) => {
                if (response.data.code == 1) {
                    commit('setToken',token);
                    commit('setLoginUser',response.data.data)
                }
            }).catch(function (error) {
                console.log(error)
            })
        }
    }
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js